import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Breadcrumbs from 'components/Breadcrumbs';
import GeneralSettingsCard from 'components/GeneralSettingsCard';
import IntegrationsCard from 'components/IntegrationsCard';
import CateringCard from 'components/CateringCard';
import PlacesCard from 'components/PlacesCard';
import LabelsCard from 'components/LabelsCard';
import CategoriesCard from 'components/CategoriesCard';
import DepartureLocationsCard from 'components/DepartureLocationsCard';
import RoomPropertiesCard from 'components/RoomPropertiesCard';
import ServicesCard from 'components/ServicesCard';
import TermsCard from 'components/TermsCard';
import TravelDocumentsCard from 'components/TravelDocumentsCard';

const SettingsPage = () => (
  <Box>
    <Breadcrumbs breadcrumbs={[{ name: 'Nustatymai' }]} />

    <Grid container spacing={2}>
      <GeneralSettingsCard />
      <PlacesCard />
      <LabelsCard />
      <CategoriesCard />
      <CateringCard />
      <DepartureLocationsCard />
      <RoomPropertiesCard />
      <ServicesCard />
      <TermsCard />
      <TravelDocumentsCard />
      <IntegrationsCard />
    </Grid>
  </Box>
);

export default SettingsPage;
